import React from "react";
import config from "../../../config";

export default function LotCard({currentLot, currency}){
    return(
        <div className="w-[85%] h-[60%]" >
            <div className="absolute right-[4%] top-[22%] z-10 bg-black text-white
                                    rounded-[15px] border border-[#E4E4E7] font-bold" style={{
                padding: "1vw 2vw",   
            }}>
                <p id='currentLotNumber' style={{ fontSize: '2vw' }} >Lot {currentLot.lot_number}</p>
            </div>
            <div className="flex flex-row h-full ">
                <div className="w-[35%] bg-[#F4F4F5] rounded-tl-[25px] rounded-bl-[25px]">
                    <div className="bg-black h-[20%] text-white px-2 flex justify-center 
                        items-center text-center rounded-tl-[25px]" style={{ fontSize: '2vw' }} >
                        {currentLot.title1}
                    </div>

                    <div className="h-[35%] border-b border-[#A1A1A9] px-2 text-center 
                        flex justify-center items-center" style={{ fontSize: '1.8vw' }} >
                        {currentLot.title2}
                    </div>
                    <div className="h-[45%] px-4 py-4 flex flex-col justify-center text-center items-center gap-[13px]">
                        <p className="text-[#070707] font-bold uppercase" style={{ fontSize: '2.4vw' }} >
                            {!currentLot.current_bid || currentLot.current_bid==0 ? 'STARTING BID' : 'CURRENT BID'}
                        </p>
                        <p className="text-[#0B8743] font-bold" style={{ fontSize: '3vw' }} >
                            {Number(!currentLot.current_bid || currentLot.current_bid==0 
                                ? currentLot.starting_price : 
                                currentLot.current_bid).toLocaleString(currency ==='INR' ? 'en-IN' : 'en-US', {
                                style: 'currency',
                                currency: currency,
                                minimumFractionDigits: 0,
                                maximumFractionDigits: 0,
                            })}
                        </p>
                        <p className="text-black font-medium" style={{ fontSize: '1.7vw' }} >
                            {currentLot.paddle_number && `PADDLE: ${currentLot.paddle_number}`}
                        </p>
                    </div>
                </div>
                <div className="w-[65%] rounded-br-[25px] overflow-hidden bg-black/40">
                    <img src={`${config.Storage.CDN}${currentLot.images.find((image) => image.featured).url}`} 
                        className="w-full h-full object-contain"
                        alt="Lot featured image" />
                </div>
            </div>
        </div>
    )
}